import React, { FC } from 'react';
import { AddPhotoAlternate } from '@mui/icons-material';
import { MenuButton, useRichTextEditorContext } from 'mui-tiptap';
import { v4 as uuid } from 'uuid';
import { mapToAttributesFromImageFigure } from '../../../figures/figureHelper';
import { GuideFigureDialog, GuideFigureDialogProps, GuideFigureDialogResult } from '../../../figures/GuideFigureDialog';
import { useModal } from '../../../../../dialogs/useModal';

export const FigureToolbarButton: FC = () => {
  const editor = useRichTextEditorContext();
  const modal = useModal<GuideFigureDialogProps, GuideFigureDialogResult>({ data: { isNew: true } });

  const handleOnClick = async () => {
    if (!editor) return;
    const figureId = uuid();
    const nodeId = uuid();

    const result = await modal.open({ editFigureId: figureId, isNew: true });
    if (result?.figure) {
      const attributes = mapToAttributesFromImageFigure(nodeId, result.figure);
      editor.chain().focus().insertImageFigure(attributes).run();
    }
  };

  if (!editor) return null;

  const canInsert = editor.isEditable && editor.can().chain().insertImageFigure().run();

  return (
    <>
      {modal.isOpen && <GuideFigureDialog {...modal} />}
      <MenuButton disabled={!canInsert} IconComponent={AddPhotoAlternate} tooltipLabel="Sett inn ny figur" onClick={handleOnClick} />
    </>
  );
};
